module.exports = __webpack_public_path__ + "img/img13.42037d98.jpg";